import React from 'react';

import { useGetPopupById } from '../api/usePopupsApi';
import { useAppContext } from '../AppContext';
import { usePopups } from '../usePopups';
import { getStoredMinimizedPopups } from './popupHelper';

export const useMinimizedPopupsRestoration = () => {
  const { appReady } = useAppContext();
  const { showPopup } = usePopups();
  const isRestored = React.useRef(false);
  const { getPopupById } = useGetPopupById();

  React.useEffect(() => {
    if (!appReady) return;

    // Mi assicuro che non venga eseguito più di una volta anche se va in errore
    if (isRestored.current) return;
    isRestored.current = true;

    const restoreMinimizedPopups = async () => {
      try {
        const minimizedPopupIds = getStoredMinimizedPopups();

        if (minimizedPopupIds.length === 0) {
          return;
        }

        // Recupero i dati di tutti i popup minimizzati dal BE
        const popupsPromises = minimizedPopupIds.map((id) =>
          // Ignoro l'errore ma lo gestisco per non far andare in errore il Promise.all
          getPopupById(id, { populate: { content: true, offer: true } }).catch(() => undefined)
        );

        const popups = await Promise.all(popupsPromises);

        popups.forEach((response) => {
          if (response?.data) {
            const popup = response.data;
            // Sovrascrivo per forzare minimizzazione immediata
            popup.startMinimized = true;
            popup.delay = 0;
            popup.showOnExit = false;
            showPopup(popup);
          }
        });
      } catch {
        // Ignoro l'errore
      }
    };

    restoreMinimizedPopups();
  }, [showPopup, getPopupById, appReady]);
};
